import "core-js/modules/es.array.push.js";
import UserService from '@/services/UserService';
import NetworkService from '@/services/NetworkService';
import SubscriptionTypes from '@/components/SubscriptionTypes';
import StreamList from '@/components/schedule/List';
import Login from '@/components/Login';
import { bus } from '@/eventBus';
export default {
  name: 'Home',
  components: {
    SubscriptionTypes,
    StreamList,
    Login
  },
  data() {
    return {
      networkInfo: null,
      userInfo: null,
      content: null,
      showLoginModal: false,
      trySearchText: ''
    };
  },
  computed: {
    isLoggedIn() {
      return !!(this.userInfo && this.userInfo.user_id > 0);
    }
  },
  async mounted() {
    await this.getNetworkInfo();
    await this.getUserInfo();
    // await this.getHomepageContent()
    const err = this.$route.query.errorMessage;
    if (err) {
      const title = this.$route.query.errorTitle ? this.$route.query.errorTitle : 'Something Went Wrong';
      this.$router.push('/').then(() => {
        this.$aim.error({}, 'error', title, err);
      });
    }
  },
  methods: {
    async getNetworkInfo() {
      this.networkInfo = await UserService.getNetworkInfo();
    },
    async getUserInfo() {
      this.userInfo = await UserService.getUserInfo();
    },
    async getHomepageContent() {
      const response = await NetworkService.getHomepageContent();
      this.content = response.data.content;
    },
    openNetworkSearch() {
      if (!this.trySearchText.trim().length) return;
      bus.$emit('openNetworkSearch', this.trySearchText.trim());
    }
  }
};